import { RootInjectorGuard } from '../guards/root-injector.guard'
import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { ErrorService } from './error.service'
import { catchError, Observable } from 'rxjs'
import { GhsClassification } from '../types/ghs'
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class GhsService extends RootInjectorGuard {
  private http = inject(HttpClient)
  private errorService = inject(ErrorService)

  private URL = environment.baseUrl + 'ghs'

  constructor() {
    super(GhsService)
  }

  getAll(): Observable<Array<GhsClassification>> {
    return this.http
      .get<Array<GhsClassification>>(this.URL)
      .pipe(catchError(this.errorService.handleError))
  }
}
